// Dizzplace - podpowiedzi pod polem szukania w naglowku (od 1600 px).
//
// Wyniki bierzemy z alternatywnego widoku `templates/search.sheet.liquid`
// (`/search?view=sheet&type=product`), czyli z tego samego zrodla co arkusz
// szukania na telefonie - jedno miejsce do zmiany ksztaltu danych.
//
// Panel jest lista kombi: pole ma role="combobox", pozycje maja role="option",
// a strzalki, Enter i Escape chodza po nich z klawiatury. Natywna liste
// wpisanych wczesniej fraz wylacza `autocomplete="off"` na polu - inaczej
// przegladarka rysuje ja NAD panelem.

(() => {
  const PROG_ZNAKOW = 2;
  const ZWLOKA = 250;
  const LIMIT = 6;

  class HeaderSearch extends HTMLElement {
    connectedCallback() {
      if (this.dataset.gotowy === '1') return;
      this.dataset.gotowy = '1';

      this.pole = this.querySelector('[data-search-input]');
      this.panel = this.querySelector('[data-search-panel]');
      this.lista = this.querySelector('[data-search-list]');
      this.pusto = this.querySelector('[data-search-empty]');
      this.wszystkie = this.querySelector('[data-search-all]');
      this.czysc = this.querySelector('[data-search-clear]');
      this.adresWynikow = this.dataset.searchUrl || '/search';
      this.licznik = 0;
      this.kontroler = null;
      this.zegar = null;
      this.aktywna = -1;
      this.pozycje = [];
      this.frazaWyniku = '';
      this.wznow = false;

      if (!this.pole || !this.panel || !this.lista) return;

      if (this.czysc) this.czysc.hidden = this.pole.value.trim() === '';

      this.pole.addEventListener('input', () => this.naWpisanie());
      this.pole.addEventListener('focus', () => {
        if (this.pozycje.length > 0) this.otworz();
      });
      this.pole.addEventListener('keydown', (zdarzenie) => this.naKlawisz(zdarzenie));

      if (this.czysc) {
        this.czysc.addEventListener('click', () => {
          this.pole.value = '';
          this.czysc.hidden = true;
          this.pole.focus();
          this.wyczysc();
        });
      }

      document.addEventListener('click', (zdarzenie) => {
        if (!this.contains(zdarzenie.target)) this.zamknij();
      });

      document.addEventListener('focusin', (zdarzenie) => {
        if (!this.contains(zdarzenie.target)) this.zamknij();
      });

      this.sledzNaglowek();
    }

    disconnectedCallback() {
      if (this.obserwator) this.obserwator.disconnect();
    }

    /* Przyklejony naglowek chowa sie przy przewijaniu w dol (klasa
       `site-header--hidden`), a panel jest od niego wyzszy, wiec sam zostalby
       wiszacy na pustym ekranie. Znika razem z paskiem i wraca razem z nim,
       gdy w polu nadal cos stoi - klient nie musi pisac frazy od nowa. */
    sledzNaglowek() {
      const naglowek = document.querySelector('[data-sticky-header]');
      if (!naglowek || !('MutationObserver' in window)) return;

      this.obserwator = new MutationObserver(() => {
        const schowany = naglowek.classList.contains('site-header--hidden');
        if (schowany) {
          if (!this.panel.hidden) {
            this.wznow = true;
            this.zamknij();
          }
          return;
        }
        if (this.wznow) {
          this.wznow = false;
          this.przywroc();
        }
      });
      this.obserwator.observe(naglowek, { attributes: true, attributeFilter: ['class'] });
    }

    /* Wyniki dla tej samej frazy wracaja bez pytania do sklepu; zmieniona
       fraza (albo wyczyszczony panel) leci po nie jeszcze raz. */
    przywroc() {
      const fraza = this.pole.value.trim();
      if (fraza.length < PROG_ZNAKOW) return;
      if (fraza === this.frazaWyniku) {
        this.otworz();
        return;
      }
      this.podpowiedz();
    }

    naWpisanie() {
      window.clearTimeout(this.zegar);
      const fraza = this.pole.value.trim();
      if (this.czysc) this.czysc.hidden = fraza === '';

      if (fraza.length < PROG_ZNAKOW) {
        this.licznik += 1;
        if (this.kontroler) this.kontroler.abort();
        this.wyczysc();
        return;
      }

      this.zegar = window.setTimeout(() => this.podpowiedz(), ZWLOKA);
    }

    async podpowiedz() {
      const fraza = this.pole.value.trim();
      if (fraza.length < PROG_ZNAKOW) return;

      const moj = (this.licznik += 1);
      if (this.kontroler) this.kontroler.abort();
      this.kontroler = new AbortController();

      const adres = new URL(this.adresWynikow, window.location.origin);
      adres.searchParams.set('q', fraza);
      adres.searchParams.set('type', 'product');
      adres.searchParams.set('view', 'sheet');
      adres.searchParams.set('options[prefix]', 'last');

      let dane = { items: [] };
      try {
        const odpowiedz = await fetch(adres.href, { signal: this.kontroler.signal });
        if (!odpowiedz.ok) throw new Error(`Search returned ${odpowiedz.status}`);
        dane = await odpowiedz.json();
      } catch (blad) {
        if (blad.name === 'AbortError') return;
      }
      if (moj !== this.licznik) return;

      const pozycje = Array.isArray(dane.items) ? dane.items.slice(0, LIMIT) : [];
      this.renderuj(pozycje, fraza);
    }

    renderuj(pozycje, fraza) {
      this.pozycje = pozycje;
      this.frazaWyniku = fraza;
      this.aktywna = -1;
      this.lista.replaceChildren();

      pozycje.forEach((pozycja, indeks) => {
        const element = document.createElement('li');
        const link = document.createElement('a');
        const tytul = document.createElement('span');

        element.className = 'site-search__option';
        element.id = `header-search-option-${indeks}`;
        element.setAttribute('role', 'option');
        element.setAttribute('aria-selected', 'false');
        link.href = pozycja.url;
        link.tabIndex = -1;
        tytul.className = 'site-search__option-title';
        tytul.textContent = pozycja.title;

        if (pozycja.image) {
          const media = document.createElement('span');
          const obraz = document.createElement('img');
          media.className = 'site-search__option-media';
          obraz.className = 'site-search__option-image';
          obraz.src = pozycja.image;
          obraz.alt = pozycja.alt || pozycja.title;
          obraz.width = 48;
          obraz.height = 48;
          obraz.loading = 'lazy';
          obraz.decoding = 'async';
          media.append(obraz);
          link.append(media);
        }

        link.append(tytul);
        element.append(link);
        this.lista.append(element);
      });

      this.lista.hidden = pozycje.length === 0;
      if (this.pusto) this.pusto.hidden = pozycje.length > 0;

      if (this.wszystkie) {
        const adres = new URL(this.adresWynikow, window.location.origin);
        adres.searchParams.set('q', fraza);
        adres.searchParams.set('type', 'product');
        this.wszystkie.href = adres.pathname + adres.search;
        this.wszystkie.hidden = pozycje.length === 0;
      }

      this.otworz();
    }

    naKlawisz(zdarzenie) {
      if (zdarzenie.key === 'Escape') {
        if (!this.panel.hidden) {
          zdarzenie.preventDefault();
          this.zamknij();
        }
        return;
      }

      if (zdarzenie.key === 'ArrowDown' || zdarzenie.key === 'ArrowUp') {
        if (this.panel.hidden || this.pozycje.length === 0) return;
        zdarzenie.preventDefault();
        const krok = zdarzenie.key === 'ArrowDown' ? 1 : -1;
        const ile = this.pozycje.length;
        let nowa = this.aktywna + krok;
        if (nowa >= ile) nowa = -1;
        if (nowa < -1) nowa = ile - 1;
        this.zaznacz(nowa);
        return;
      }

      if (zdarzenie.key === 'Enter' && this.aktywna >= 0) {
        const link = this.lista.children[this.aktywna]?.querySelector('a');
        if (link) {
          zdarzenie.preventDefault();
          window.location.href = link.href;
        }
      }
    }

    /* Indeks -1 znaczy "kursor wrocil do pola" - wtedy zadna pozycja nie jest
       podswietlona, a Enter wysyla formularz do pelnych wynikow. */
    zaznacz(indeks) {
      this.aktywna = indeks;

      Array.from(this.lista.children).forEach((element, i) => {
        const aktywna = i === this.aktywna;
        element.classList.toggle('site-search__option--aktywna', aktywna);
        element.setAttribute('aria-selected', aktywna ? 'true' : 'false');
        if (aktywna) element.scrollIntoView({ block: 'nearest' });
      });

      if (this.aktywna >= 0) {
        this.pole.setAttribute('aria-activedescendant', `header-search-option-${this.aktywna}`);
      } else {
        this.pole.removeAttribute('aria-activedescendant');
      }
    }

    otworz() {
      this.panel.hidden = false;
      this.pole.setAttribute('aria-expanded', 'true');
    }

    zamknij() {
      this.panel.hidden = true;
      this.pole.setAttribute('aria-expanded', 'false');
      this.pole.removeAttribute('aria-activedescendant');
      this.aktywna = -1;
    }

    wyczysc() {
      this.pozycje = [];
      this.frazaWyniku = '';
      this.wznow = false;
      this.lista.replaceChildren();
      this.lista.hidden = true;
      if (this.pusto) this.pusto.hidden = true;
      if (this.wszystkie) this.wszystkie.hidden = true;
      this.zamknij();
    }
  }

  if (!customElements.get('header-search')) {
    customElements.define('header-search', HeaderSearch);
  }

  /* Strona wynikow: wyczyszczenie pola (do zera albo krzyzykiem) wraca do
     pustego wyszukiwania - wczesniej zamykaly sie tylko podpowiedzi, a na
     ekranie zostawaly wyniki starej frazy (zgloszenie usera 27.10.2026).
     Dotyczy pola w naglowku i pola na samej stronie wynikow. */
  const naStronieWynikow = () => /\/search\/?$/.test(window.location.pathname)
    && new URLSearchParams(window.location.search).get('q');
  const wrocDoPustego = (pole) => {
    if (!naStronieWynikow() || pole.value.trim() !== '') return;
    const formularz = pole.form;
    const adres = formularz ? formularz.getAttribute('action') : window.location.pathname;
    window.location.assign(adres || window.location.pathname);
  };
  let zegarCzyszczenia = null;
  document.addEventListener('input', (zdarzenie) => {
    const pole = zdarzenie.target;
    if (!pole.matches || !pole.matches('.site-search__input, .search-page__input')) return;
    window.clearTimeout(zegarCzyszczenia);
    zegarCzyszczenia = window.setTimeout(() => wrocDoPustego(pole), 400);
  });
  document.addEventListener('click', (zdarzenie) => {
    if (!zdarzenie.target.closest('[data-search-clear]')) return;
    const pole = zdarzenie.target.closest('header-search')?.querySelector('.site-search__input');
    if (pole) window.setTimeout(() => wrocDoPustego(pole), 0);
  });
})();
